import { Routes } from '@angular/router';
import {
  SlideShowDefaultService,
  SlideShowLockedService,
} from './service/slide-show.service';
import { SlideShowRepository } from './repositories/slide-show.repository';
import { configuredGuard } from './resolvers/configured.guard';
import { SOFTLINE_TOKEN_WWS_POS_DISPLAY_SLIDE_SHOW_SERVICE } from './pos-display.shared';

export const posDisplayRoutes: Routes = [
  {
    path: 'pos-display/config',
    loadComponent: () => import('./pages/config/config.component'),
  },
  {
    path: 'pos-display',
    canActivate: [configuredGuard],
    loadComponent: () => import('./pages/pos-display.component'),
    loadChildren: () => [
      {
        path: 'slide-show',
        loadComponent: () =>
          import('./pages/displays/slide-show-page/slide-show-page.component'),
        providers: [
          SlideShowRepository,
          {
            provide: SOFTLINE_TOKEN_WWS_POS_DISPLAY_SLIDE_SHOW_SERVICE,
            useClass: SlideShowDefaultService,
          },
        ],
      },
      {
        path: 'locked-slide-show',
        loadComponent: () =>
          import('./pages/displays/slide-show-page/slide-show-page.component'),
        providers: [
          SlideShowRepository,
          {
            provide: SOFTLINE_TOKEN_WWS_POS_DISPLAY_SLIDE_SHOW_SERVICE,
            useClass: SlideShowLockedService,
          },
        ],
      },
      {
        path: 'cart',
        loadComponent: () => import('./pages/displays/cart-page/cart-page.component'),
      },
      {
        path: 'payment',
        loadComponent: () =>
          import('./pages/displays/payment-page/payment-page.component'),
      },
      {
        path: 'finalize',
        loadComponent: () =>
          import('./pages/displays/finalize-page/finalize-page.component'),
      },
      {
        path: 'signature/:type/:id',
        loadComponent: () =>
          import('./pages/displays/signature-page/signature-page.component'),
      },
      {
        path: '**',
        redirectTo: 'slide-show',
      },
    ],
  },
];
